export default {
  edit: "translation:edit",
  create: "translation:create",
  delete: "translation:delete",
  view: "translation:view",
};
